import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55e32cec"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 1,
  class: "fallback-wrapper"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "progress" }

import fallbackIcon from '@shared/assets/img/cinema-fallback-icon.png'
import { PropType, ref, watch } from 'vue'



export default /*#__PURE__*/_defineComponent({
  props: {
  isPosterShow: {
    type: Boolean,
    default: true,
  },
  img: {
    type: String,
    default: '',
  },
  progress: {
    type: Number,
    default: 0,
  },
  theme: {
    type: Object as PropType<0|1|2|3|4|null>,
    default: null,
  },
},
  setup(__props) {

const props = __props

const colorScheme = ref(Math.floor((Math.random() * 5)))



const imgNodeRef = ref<HTMLImageElement | null>(null)

const isPosterShowLocal = ref(props.isPosterShow)

watch(() => props.isPosterShow, (val) => {
  isPosterShowLocal.value = val
})

const loadFallback = () => {
  isPosterShowLocal.value = false // 不展示图片，就会展示默认兜底
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['img-wrapper', `scheme-${props.theme ?? colorScheme.value}` ])
  }, [
    (__props.img && isPosterShowLocal.value)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          ref_key: "imgNodeRef",
          ref: imgNodeRef,
          src: __props.img ?? '',
          draggable: "false",
          onError: loadFallback
        }, null, 40, _hoisted_1))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("img", {
            class: "fallback",
            draggable: "false",
            src: _unref(fallbackIcon)
          }, null, 8, _hoisted_3)
        ])),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: "progress-bar",
        style: _normalizeStyle({ width: `${__props.progress}%` })
      }, null, 4)
    ])
  ], 2))
}
}

})